import { EventType } from "../../../../controller/MasterController";
import { langText } from "../../../../recoil/lang";
import TimeRecommendList from "../timeRecommendList";
import { Style } from "./style";
import { EventContentViewProps } from "./type";

export default function EventContentView({
  props,
  hook,
}: EventContentViewProps) {
  const EventSection = (oProps: { item: EventType }) => {
    return (
      <div
        onClick={() => {
          hook.openEvent(oProps.item);
        }}
        className="imageBox"
        style={{ width: "100%", height: "65vh" }}
      >
        <img
          src={
            oProps.item.event_banner_url ||
            `${process.env.PUBLIC_URL}/knockknock/img/newYear/eventBanner_new_year.png`
          }
          alt="이벤트 banner"
          style={{
            width: "100%",
          }}
        />
      </div>
    );
  };

  const StoreSection = () => {
    return (
      <>
        {props.adverList &&
          props.adverList.map((data, index) => (
            <div className="adverStoreWrap" key={index}>
              <div className="storeName">
                <h2>{data.store_name}</h2>
              </div>
              <div
                key={data.file_name}
                onClick={() => {
                  props.navigateAdStore(data.store_id);
                  hook.adverClick(data.store_id, data.store_name);
                }}
              >
                {data.mime_type.includes("image") && (
                  <div className="imageBox">
                    <img
                      className="adImg"
                      src={data.url_path}
                      alt="광고이미지"
                    />
                  </div>
                )}
                {data.mime_type.includes("video") && (
                  <div className="imageBox">
                    <video
                      className="adVideo"
                      id={`${data.file_name}`}
                      autoPlay
                      onEnded={() => hook.handleVideoEnd(index)}
                      muted
                      preload="auto"
                    >
                      <source src={data.full_path} type="video/mp4" />
                    </video>
                  </div>
                )}
              </div>
              <div
                className="movement store"
                onClick={() => {
                  props.navigateAdStore(data.store_id);
                  hook.adverClick(data.store_id, data.store_name);
                }}
              >
                <h3>{langText.storeSelector_button_menu[hook.lang]}</h3>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_black.svg`}
                  alt="storeMovement"
                />
              </div>
            </div>
          ))}
      </>
    );
  };

  return hook.adverFlag ? (
    <Style>
      <div className="mediaWrap">
        <div
          onClick={hook.resetPage}
          style={{ width: "100%", height: "100vh" }}
        />
        <div className="eventPageWrap">
          <button className="closeButton" onClick={hook.resetPage}>
            <p>{langText.close[hook.lang]}</p>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="closeButton"
            />
          </button>

          <div className="adverBackground">
            <div
              className="slideBtn left"
              onClick={() => hook.slideHandler(-1)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_event_arrow_left.svg`}
                alt="prevEventButton"
                style={{ width: "55px", height: "55px" }}
              />
            </div>
            {((props.eventList && props.eventList.length > 0) ||
              (props.adverList && props.adverList.length > 0) ||
              hook.timeRecommendListEnabled === 1) && (
              <div
                className="imgContainer"
                style={{
                  transform: `translateX(-${hook.slideIndex * 100}%)`,
                }}
                ref={hook.sliderRef}
              >
                {props.eventList &&
                  props.eventList.map((item: EventType, index: number) => (
                    <EventSection item={item} key={index} />
                  ))}

                {/* 매장 커스텀 광고 */}
                {hook.timeRecommendListEnabled && (
                  <TimeRecommendList
                    lang={hook.lang}
                    timeSectorRecommend={props.timeSectorRecommend}
                    navigateAdStore={props.navigateAdStore}
                    adverClick={hook.adverClick}
                  />
                )}
                {/* 매장광고 */}
                <StoreSection />
              </div>
            )}
            <div
              className="slideBtn right"
              onClick={() => hook.slideHandler(1)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_event_arrow_right.svg`}
                alt="nextEventButton"
                style={{ width: "55px", height: "55px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </Style>
  ) : (
    <></>
  );
}
